"use client";

import { createContext, useContext, useMemo } from "react";

export interface GlobalTextMap {
  [key: string]: string | null | undefined;
}

const DEFAULT_TEXT: GlobalTextMap = {
  cancelText: "キャンセル",
  closeText: "閉じる",
};

const GlobalTextContext = createContext<GlobalTextMap>(DEFAULT_TEXT);

export function useGlobalText() {
  return useContext(GlobalTextContext);
}

export function GlobalTextProvider({
  value = {},
  children,
}: Readonly<{
  value?: Partial<GlobalTextMap>;
  children: React.ReactNode;
}>) {
  const mergedValue = useMemo(() => {
    return {
      ...DEFAULT_TEXT,
      ...Object.fromEntries(
        Object.entries(value).map(([key, v]) => [
          key,
          v ?? DEFAULT_TEXT[key] ?? "",
        ]),
      ),
    };
  }, [value]);

  return (
    <GlobalTextContext.Provider value={mergedValue}>
      {children}
    </GlobalTextContext.Provider>
  );
}
